module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.ba0badb.woff2";